"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var CookieSetError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(CookieSetError, _Error);

  function CookieSetError(message) {
    var _this;

    (0, _classCallCheck2.default)(this, CookieSetError);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CookieSetError).call(this, message || 'Could not set cookie'));
    _this.name = 'CookieSetError';
    return _this;
  }

  return CookieSetError;
}((0, _wrapNativeSuper2.default)(Error));

var _default = CookieSetError;
exports.default = _default;
module.exports = exports.default;